module.exports = __webpack_public_path__ + "img/remove_circle_white_24dp.6755855f.svg";